import React, { useEffect, useState, useContext } from 'react';
import {
  Box, Typography, Card, CardContent,
  Accordion, AccordionSummary, AccordionDetails,
  Stack, Button, Badge
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { useParams, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../auth/AuthContext';
import studioApi from '../../api/studioApi';
import documentoApi from '../../api/documentoApi';
import contribuenteApi from '../../api/contribuenteApi';
import filesApi from '../../api/filesApi';
import KpiCard from '../../components/KpiCard';
import { formatDate } from '../../utils/dateFormatter';
import ProtectedAction from '../../components/ProtectedAction';

export default function DashboardStudioMobile() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  const [studio, setStudio] = useState(null);
  const [documenti, setDocumenti] = useState([]);
  const [totContribuenti, setTotContribuenti] = useState(0);
  const [scadenzeProssime, setScadenzeProssime] = useState(0);
  const [scadenzeScadute, setScadenzeScadute] = useState(0);
  const [totDocumenti, setTotDocumenti] = useState(0);
  const [totRateSaltate, setTotRateSaltate] = useState(0);

  useEffect(() => {
    fetchStudio();
    fetchContribuenti();
    fetchDocumenti();
  }, [id]);

  const fetchStudio = async () => {
    const res = await studioApi.get(id);
    setStudio(res.data);
  };

  const fetchContribuenti = async () => {
    const res = await contribuenteApi.listbystudio(id, { page: 0, size: 10000 });
    setTotContribuenti(res.data.content.length);
  };

  const fetchDocumenti = async () => {
    const res = await documentoApi.listbystudio(user.userId, { page: 0, size: 10 });
    const docs = res.data.content || [];

    let prossime = 0, scadute = 0, rate = 0;
    docs.forEach(d => {
      rate += d.rateSaltate || 0;
      d.scadenze?.forEach(s => {
        const diff = (new Date(s.data) - new Date()) / 86400000;
        if (diff < 0) scadute++;
        else if (diff <= 7) prossime++;
      });
    });

    setDocumenti(docs);
    setTotDocumenti(docs.length);
    setTotRateSaltate(rate);
    setScadenzeProssime(prossime);
    setScadenzeScadute(scadute);
  };

  const openPdf = async (path) => {
    const res = await filesApi.getfile(path);
    const url = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
    window.open(url, '_blank');
    URL.revokeObjectURL(url);
  };

  if (!studio) return <div>Loading...</div>;

  return (
    <>
      {/* HEADER */}
      <Box sx={{ p: 2 }}>
        <Typography variant="h6">
          🏢 {studio.username || studio.nome}
        </Typography>
      </Box>

      {/* KPI */}
      <Stack spacing={2} sx={{ px: 2 }}>
        <KpiCard title="Contribuenti" value={totContribuenti} />
        <KpiCard title="Documenti" value={totDocumenti} />
        <KpiCard title="Rate saltate" value={totRateSaltate} color="error" />
        <KpiCard title="Scadenze prossime" value={scadenzeProssime} color="warning" />
        <KpiCard title="Scadenze scadute" value={scadenzeScadute} color="error" />
      </Stack>

      {/* CONTRATTO */}
      <Card sx={{ m: 2 }}>
        <CardContent>
          <Typography variant="subtitle2">Contratto</Typography>
          <Typography>Tipo: {studio.contratto?.tipocontratto?.tipo || '—'}</Typography>
          <Typography>Canone: € {studio.contratto?.canoneAnnuo || '—'}</Typography>
          <Typography>Scadenza: {studio.contratto?.dataFine || '—'}</Typography>
        </CardContent>
      </Card>

      {/* DOCUMENTI */}
      <Typography sx={{ px: 2, mt: 2 }} variant="subtitle1">
        Documenti recenti
      </Typography>

      <Stack spacing={1} sx={{ px: 2 }}>
        {documenti.map(d => (
          <Accordion key={d.id}>
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Stack direction="row" justifyContent="space-between" sx={{ width: '100%' }}>
                <Typography>{d.tipo}</Typography>
                {d.rateSaltate > 0 &&
                  <Badge color="error" badgeContent={d.rateSaltate}><span /></Badge>}
              </Stack>
            </AccordionSummary>

            <AccordionDetails>
              <Typography variant="body2">
                {d.contribuente?.nome} {d.contribuente?.cognome}
              </Typography>
              <Typography variant="caption">
                Creato il {formatDate(d.dataCreazione)}
              </Typography>

              <Stack spacing={1} sx={{ mt: 1 }}>
                <Button size="small" onClick={() => navigate(`/documenti/${d.id}`)}>
                  Dettaglio
                </Button>
              </Stack>
            </AccordionDetails>
          </Accordion>
        ))}
      </Stack>
    </>
  );
}
